import { useLocation, useNavigate, useParams } from 'react-router'

import { useEntityProfileTabsActiveTab } from '../../../../Entity'

import { getViewingProfileTabUrl } from './useViewingProfileTabsActiveTab.utils'

export function useViewingProfileTabsActiveTab({ preparedTabs, viewingData }) {
  const navigate = useNavigate()

  const location = useLocation()

  const { viewingId } = useParams()

  function getTabUrl(tab) {
    return getViewingProfileTabUrl({ tab, viewingId })
  }

  const { activeTabId } = useEntityProfileTabsActiveTab({
    getTabUrl,
    isEntityLoaded: Boolean(viewingData),
    preparedTabs,
  })

  function handleSetActiveTab(tabId) {
    navigate(
      {
        hash: location.hash,
        pathname: getTabUrl(tabId),
        search: location.search,
      },
      { replace: true }
    )
  }

  return { activeTabId, handleSetActiveTab }
}
